import React from 'react'
import { Container, Box } from '@mui/material'
import SearchField from 'components/SearchField'
import DebugViewer from 'components/DebugViewer'
import BoardViewer from 'components/BoardViewer'
import { useAtomValue } from 'jotai'
import PictoControls from 'components/PictoControls'
import { hasPictogramsAtom, isDevEnabledAtom } from 'atoms'
import PictogramsViewer from 'components/PictogramsViewer/PictogramsViewer'

function Araword() {
  const hasPictograms = useAtomValue(hasPictogramsAtom)
  const isDevEnabled = useAtomValue(isDevEnabledAtom)

  return (
    <Container maxWidth="xl">
      <Container maxWidth="lg">
        <Box my={4}>
          <SearchField />
          {hasPictograms && isDevEnabled && <DebugViewer />}
        </Box>

        {hasPictograms && (
          <Box my={4}>
            <Box my={4}>
              <PictoControls />
            </Box>
            <Box my={4}>
              <PictogramsViewer />
            </Box>
          </Box>
        )}
      </Container>

      {hasPictograms && <BoardViewer />}
    </Container>
  )
}

export default Araword
